"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEMKIT_UI_TABS_REFRESH_SOURCE = exports.CHEMKIT_DASHBOARD_CONFIG_WINDOW_KEY = void 0;
exports.CHEMKIT_DASHBOARD_CONFIG_WINDOW_KEY = "__CHEMKIT_DASHBOARD_CONFIG__";
exports.CHEMKIT_UI_TABS_REFRESH_SOURCE = "window.chemkit.ui.tabs.refresh";
